/* eslint-disable @typescript-eslint/no-explicit-any */
import * as actions from "store/actions/dasn";
import IDasn from "Types/Dasn";

export interface DasnState {
	items: IDasn[];
	filter: any[];
	pages: any;
	count: number;
	loading: any;
	errors: any;
}

interface MyAction {
	type: string;
	payload: any;
}

const initialState: DasnState = {
	items: [],
	filter: [],
	pages: null,
	count: 0,
	loading: { getAll: false, import: false },
	errors: {}
};

const reducer = function (state = initialState, action: MyAction) {
	const { type, payload } = action;
	switch (type) {
		case actions.GET_DASN: {
			return {
				...state,
				loading: { getAll: true },
				errors: initialState.errors
			};
		}
		case actions.GET_DASN_SUCCESS: {
			return {
				...state,
				items: payload || [],
				loading: { getAll: false }
			};
		}
		case actions.GET_DASN_FAILED: {
			return {
				...state,
				loading: { getAll: false },
				errors: payload
			};
		}
		case actions.GENERATE_DASN: {
			return {
				...state,
				loading: { import: true },
				errors: initialState.errors
			};
		}
		case actions.GENERATE_DASN_SUCCESS: {
			return {
				...state,
				loading: { import: false }
			};
		}
		case actions.GENERATE_DASN_FAILED: {
			return {
				...state,
				loading: { import: false },
				errors: payload
			};
		}
		case actions.SET_VALUE:
			return {
				...state,
				...payload
			};
		case actions.CLEAR_VALUES:
			return {
				...initialState
			};
		default: {
			return state;
		}
	}
};

export default reducer;
